module.exports = __webpack_public_path__ + "img/ic_maru.5557376e.svg";